import {
  FormulaOperation,
  FormulaTokenType,
  ParseResult,
  ParseResultType,
  PartialParseResult
} from "./types";

import { match, tail } from "ramda";

const parseFormula = (formulaString: string): ParseResult => {
  const stringsTokens = tokenizeString(formulaString);

  const partialParseResult: PartialParseResult = {
    status: ParseResultType.Ok,
    result: { type: FormulaTokenType.End }
  };

  const fullParse: PartialParseResult = addTokens(
    stringsTokens,
    partialParseResult
  );

  if (fullParse.status === ParseResultType.Error) {
    return [ParseResultType.Error, fullParse.result];
  }

  if (fullParse.status === ParseResultType.Ok) {
    switch (fullParse.result.type) {
      case FormulaTokenType.Operation: {
        return [ParseResultType.Error, "Formula must start with one id"];
      }
      case FormulaTokenType.End: {
        return [ParseResultType.Error, "Formula must have at least one id"];
      }
      case FormulaTokenType.Id: {
        return [ParseResultType.Ok, fullParse.result];
      }
    }
  }

  return [ParseResultType.Error, "Not implemented"];
};

export const tokenizeString = (input: string): string[] => {
  return match(/([\w_]+|\+|-)/g, input);
};

export const addTokens = (
  tokens: string[],
  partialResult: PartialParseResult
): PartialParseResult => {
  if (tokens.length === 0) {
    return partialResult;
  }
  const headToken = tokens[0];
  const tailTokens = tail(tokens);
  return addToken(headToken, addTokens(tailTokens, partialResult));
};

export const addToken = (
  newToken: string,
  partialResult: PartialParseResult
): PartialParseResult => {
  if (partialResult.status === ParseResultType.Error) {
    return partialResult;
  }

  switch (newToken) {
    case "+":
    case "-": {
      if (partialResult.result.type !== FormulaTokenType.Id) {
        return {
          status: ParseResultType.Error,
          result: "Operations must have a predicate"
        };
      }
      return {
        status: ParseResultType.Ok,
        result: {
          type: FormulaTokenType.Operation,
          value:
            newToken === "+" ? FormulaOperation.Add : FormulaOperation.Subtract,
          next: partialResult.result
        }
      };
    }
    default:
      if (partialResult.result.type === FormulaTokenType.Id) {
        return {
          status: ParseResultType.Error,
          result: "Two Ids must be separated by an operation"
        };
      }
      return {
        status: ParseResultType.Ok,
        result: {
          type: FormulaTokenType.Id,
          value: newToken,
          next: partialResult.result
        }
      };
  }
};

export default parseFormula;



// WEBPACK FOOTER //
// ./src/spread/model/derivedModel/formulas/parseFormula.ts